/* eslint-disable no-restricted-imports */
import Link from 'next/link';
import GameBadge from '~/client/shared/GameBadge';
import useGameHeader from './useGameHeader';
import MobileGameThumbnail from '../MobileGameThumbnail';

const GameHeader: FC = () => {
  const { game, href, providerName } = useGameHeader();
  if (!game) {
    return null;
  }
  return (
    <div className="inline-container flex-nowrap items-start gap-1">
      <MobileGameThumbnail game={game} height={64} />
      <div className="ml-2 grid justify-start justify-items-start self-center">
        <GameBadge game={game} />
        <h1 className="text-moon-20 font-medium text-bulma">{game.name}</h1>
        <Link href={href}>
          <p className="text-moon-10-caption font-medium uppercase text-trunks">
            {providerName}
          </p>
        </Link>
      </div>
    </div>
  );
};

export default GameHeader;
